import { ContentColumn } from "@/app/app-shell";
import { useProjectContext } from "@/app/project-context";
import { BrainTabs } from "@/features/brain/brain-tabs";
import { QuestionHistory } from "./question-history";

/**
 * The Brain's History tab: every question asked of this project, newest first
 * (the owner, 2026-09-27, `product/0013`).
 *
 * In the chat folder, beside the Ask screen, because a row here is a question
 * and opens in Ask. The tab bar is the Brain's; the list is the one that used
 * to sit under the ask box.
 */
export function HistoryScreen() {
  const { projectId } = useProjectContext();

  return (
    <ContentColumn tight>
      <BrainTabs />
      <QuestionHistory projectId={projectId} />
    </ContentColumn>
  );
}
